import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { reportsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types/common/requests";

const useDownloadReportMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		async ({
			id,
			fileFormat,
			token,
		}: {
			id: string;
			fileFormat: string | number;
			token: string;
		}) => {
			if (!token) return Promise.reject("Token is missing");
			return reportsService.downloadReport(id, fileFormat, token);
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Report has been downloaded successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useDownloadReportMutation;
